import { render, staticRenderFns } from "./MiniCompare.vue?vue&type=template&id=381ae6de&"
import script from "./MiniCompare.vue?vue&type=script&lang=js&"
export * from "./MiniCompare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CA5\\PhpstormProjects\\te-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('381ae6de', component.options)
    } else {
      api.reload('381ae6de', component.options)
    }
    module.hot.accept("./MiniCompare.vue?vue&type=template&id=381ae6de&", function () {
      api.rerender('381ae6de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Pages/page-part/MiniCompare.vue"
export default component.exports